import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, number, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isOfferfitAppGroupIdGetPrimaryKpiResult = objectOf({
  dates: arrayOf(string),
  denominator_base: number,
  denominator_comparison: number,
  display_unit: anyOf(string, nullOrUndefined),
  numerator_base: number,
  numerator_comparison: number,
  uplift: number,
  uplift_rolling_1: arrayOf(anyOf(number, nullOrUndefined)),
  uplift_rolling_7: arrayOf(anyOf(number, nullOrUndefined)),
  uplift_rolling_30: arrayOf(anyOf(number, nullOrUndefined)),
  value_base: number,
  value_comparison: number,
  values_base_rolling_1: arrayOf(anyOf(number, nullOrUndefined)),
  values_base_rolling_7: arrayOf(anyOf(number, nullOrUndefined)),
  values_base_rolling_30: arrayOf(anyOf(number, nullOrUndefined)),
  values_comp_rolling_1: arrayOf(anyOf(number, nullOrUndefined)),
  values_comp_rolling_7: arrayOf(anyOf(number, nullOrUndefined)),
  values_comp_rolling_30: arrayOf(anyOf(number, nullOrUndefined)),
});
